import Popover from "react-bootstrap/Popover";
import React from "react";

export const popoverActive = (
    <Popover
        id="popover-trigger-hover-focus"
        title="Account Active"
    >
        Set the state of the Account. Inactive accounts and all associated locations/devices will not be visible
        to the client
    </Popover>
);

export const popoverSuspended = (
    <Popover
        id="popover-trigger-hover-focus"
        title="Account Suspended"
    >
        Set the suspended state of the account. Suspended accounts and all associated locations/devices will not be visible
        to the client
    </Popover>
);